// extracted by mini-css-extract-plugin
module.exports = {"formErrorWrapper":"index_7ZWlJ","buttonsWrapper":"index_20zaV"};